import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import SubmitButton from "../../../../components/button/SubmitButton";
import StyledInput from "../../../../components/styledInput/StyledInput";
import { TrashIcon } from "../../../../assets/icons";
import React, { useState, useEffect, useMemo } from "react";
import ApiDatabase from "../../../../server";

const ModalEditQualification = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const qualification = modalData?.qualification;
  const onSuccess = modalData?.onSuccess;
  const onDeleteRequest = modalData?.onDeleteRequest;

  useEffect(() => {
    if (qualification?.name) {
      setName(qualification.name);
    }
  }, [qualification]);

  const canSubmit = useMemo(() => name.trim().length > 0, [name]);

  const handleSubmit = () => {
    if (!name.trim() || !qualification?._id) return;
    setSubmitting(true);
    ApiDatabase.putUpdateQualification(
      { id: qualification._id, name: name.trim() },
      () => {
        setSubmitting(false);
        if (onSuccess) onSuccess();
        toggle();
      },
      () => setSubmitting(false)
    );
  };

  const handleDeleteClick = () => {
    if (onDeleteRequest) {
      onDeleteRequest(qualification);
    }
    toggle();
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Modifier un poste
      </Modalheader>
      <ModalBody>
        <StyledInput
          type="text"
          label="Nom du poste"
          placeholder="Ex : manutentionnaire"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <div className="flex w-full items-center justify-between">
          <Button
            color="SECONDARY"
            size="LG"
            onClick={handleDeleteClick}
          >
            <div className="flex items-center gap-1">
              <TrashIcon wh={20} color="#374151" />
              Supprimer
            </div>
          </Button>
          <div className="flex gap-2">
            <Button color="SECONDARY" size="LG" onClick={toggle}>
              Annuler
            </Button>
            <SubmitButton
              loading={submitting}
              onClick={handleSubmit}
              disabled={!canSubmit}
            />
          </div>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalEditQualification;
